import { useState, useEffect } from 'react';

// Obtener del localStorage
export const getStorageItem = (key, defaultValue) => {
  try {
    const item = localStorage.getItem(key);
    const parsedItem = item ? JSON.parse(item) : null;
    if (parsedItem === null || (Array.isArray(defaultValue) && !Array.isArray(parsedItem))) {
      return defaultValue;
    }
    return parsedItem;
  } catch (error) {
    console.error("Error al obtener de localStorage:", error);
    return defaultValue;
  }
};

// Guardar en localStorage
export const setStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error al guardar en localStorage:", error);
  }
};

// Hook personalizado con clave dinámica por usuario
export const useLocalStorage = (key, defaultValue, isGlobal = false) => {
  const [value, setValue] = useState(() => {
    const currentUser = getStorageItem('eleda_currentUser', null);
    const storageKey = isGlobal ? key : (currentUser ? `${key}_${currentUser.user_id}` : key);
    return getStorageItem(storageKey, defaultValue);
  });

  useEffect(() => {
    const currentUser = getStorageItem('eleda_currentUser', null);
    const storageKey = isGlobal ? key : (currentUser ? `${key}_${currentUser.user_id}` : key);
    setStorageItem(storageKey, value);
  }, [key, value, isGlobal]);

  return [value, setValue];
};

// Generador de ID único
export const generateUniqueId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};
